import React, { useEffect, useState } from 'react';
import { deletURLParam, formattedMoney, getURLParam, lockBody, setURLParam, unlockBody } from '../../helpers/utilities';
import { IconCross } from '../icons/Icons';
import cartUtil from '../..//helpers/cartUtil';
const initialSelectedState = {
    variant: null,
    addOns: [],
};
const bundlePriceInitial = {
    totalBase: null,
    totalCompare: null,
    colours: [],
    addons: [],
};
const VariantsContainer = ({ translations, addons, variants, options, selected_or_first_available_variant, available }) => {
    const [bundlePrice, setBundlePrice] = useState(bundlePriceInitial);
    const [currentBundle, setCurrentBundle] = useState(initialSelectedState);
    const [activeAddOn, setActiveAddOn] = useState(null);
    const [addOnModalOpen, setAddOnModalOpen] = useState(false);
    const [bundleLoaded, setBundleLoaded] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [addingToCart, setAddingToCart] = useState(false);
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        let selectedAddons = [];
        let selectedVariant = null;
        // Quanity changes
        const quantityChanger = document.querySelector('.product-block > .product__quantity > input');
        if (quantityChanger) {
            quantityChanger.addEventListener('change', (event) => {
                // @ts-ignore
                setQuantity(Number(event.target.value));
            });
        }
        // Get variant from URL
        const variantInURL = searchParams.get('variant');
        if (!variantInURL) {
            // If no current variant, select default
            setURLParam('variant', selected_or_first_available_variant.id);
            selectedVariant = selected_or_first_available_variant;
        }
        else {
            selectedVariant = variants.filter((variant) => variant.id === Number(variantInURL))[0];
        }
        if (addons.length) {
            const addOnsInURL = getURLParam('addon');
            let preSelectedAddons;
            if (addOnsInURL) {
                const allAddOns = addOnsInURL.split('-');
                preSelectedAddons = addons.filter((addOn) => allAddOns.includes(addOn.id.toString()));
            }
            else {
                preSelectedAddons = addons.filter((addOn) => addOn.pre_selected);
            }
            if (preSelectedAddons.length) {
                selectedAddons = preSelectedAddons;
                setURLParam('addon', selectedAddons.length > 1 ? selectedAddons.map((item) => item.id).join('-') : selectedAddons[0].id);
            }
        }
        setCurrentBundle({
            variant: selectedVariant,
            addOns: selectedAddons,
        });
    }, []);
    useEffect(() => {
        // Bundle loaded
        const skeleton = document.querySelector('.bundle-skeleton');
        if (skeleton) {
            skeleton.classList.add('bundle-skeleton-hide');
            setBundleLoaded(true);
        }
    });
    const calculatePrices = () => {
        let bundleTotalPrice = currentBundle.variant.price;
        let bundleTotalComparePrice = currentBundle.variant.compare_at_price ? currentBundle.variant.compare_at_price : currentBundle.variant.price;
        currentBundle.addOns.forEach((addOn) => {
            bundleTotalPrice += addOn.price;
            bundleTotalComparePrice += addOn.compare_at_price ? addOn.compare_at_price : addOn.price;
        });
        const prices = {
            totalBase: bundleTotalPrice,
            totalCompare: bundleTotalComparePrice,
            addons: currentBundle.addOns.map((addon) => addon.price),
        };
        setBundlePrice(prices);
    };
    useEffect(() => {
        if (currentBundle.variant) {
            calculatePrices();
        }
    }, [currentBundle]);
    const prepareAddToCartData = () => {
        const setAddOns = currentBundle.addOns.map((addOn, index) => {
            return {
                id: addOn.id,
                quantity: 1,
            };
        });
        const selectedOptionsData = [
            {
                id: currentBundle.variant.id,
                quantity: quantity,
            },
            ...setAddOns,
        ];
        return selectedOptionsData;
    };
    const addBundleToCart = () => {
        setAddingToCart(true);
        const productsToAdd = prepareAddToCartData();
        cartUtil
            .add(productsToAdd)
            .then(() => setAddingToCart(false))
            .catch(() => setAddingToCart(false));
    };
    const handleCloseModal = (modal) => {
        if (modal === 'add-on') {
            setAddOnModalOpen(false);
        }
        unlockBody();
    };
    const removeAddOn = () => {
        const addOnsInUrl = getURLParam('addon').split('-');
        if (addOnsInUrl.length <= 1) {
            deletURLParam('addon');
        }
        else {
            const remainingAddOns = addOnsInUrl.filter((addonID) => Number(addonID) != activeAddOn.id);
            setURLParam('addon', remainingAddOns.length > 1 ? remainingAddOns.join('-') : remainingAddOns[0]);
        }
        setCurrentBundle({
            variant: currentBundle.variant,
            addOns: currentBundle.addOns.filter((item) => item.id != activeAddOn.id),
        });
        handleCloseModal('add-on');
    };
    const addAddOnItem = (id) => {
        const inBundle = currentBundle.addOns.filter((item) => item.id === id);
        if (inBundle.length) {
            // show modal
            const currentAddOn = inBundle[0];
            setActiveAddOn(currentAddOn);
            lockBody();
            setAddOnModalOpen(true);
        }
        else {
            const addOnToAdd = addons.filter((item) => item.id === id);
            const newAddOns = [...currentBundle.addOns, ...addOnToAdd];
            const addonsURL = newAddOns.map((addOnItem) => addOnItem.id).join('-');
            setURLParam('addon', addonsURL);
            setCurrentBundle({
                variant: currentBundle.variant,
                addOns: newAddOns,
            });
        }
    };
    const selectNewVariant = (value, optionIndex) => {
        const newOptions = currentBundle.variant.options.map((option, index) => (index == optionIndex ? value : option));
        const newVariant = variants.filter((variant) => variant.options.join('-') === newOptions.join('-'))[0];
        if (newVariant) {
            setURLParam('variant', newVariant.id);
            setCurrentBundle({
                variant: newVariant,
                addOns: currentBundle.addOns,
            });
        }
    };
    if (currentBundle.variant == null) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `bundle-details ${bundleLoaded ? 'bundle-loaded' : 'bundle-loading'}` },
            React.createElement("div", { className: "bundle-details__options" }, options.map((option, optionIndex) => {
                if (option.values.length == 1) {
                    return null;
                }
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "bundle-details__options--header" },
                        React.createElement("h4", { className: "bundle-details__section-title" }, option.name)),
                    React.createElement("div", { className: "bundle-details__options--wrapper" }, option.values.map((value, index) => {
                        return (React.createElement("button", { key: index, onClick: () => selectNewVariant(value, optionIndex), className: `bundle-details__options--option ${currentBundle.variant.options.indexOf(value) != -1 ? 'selected' : ''}` }, value));
                    }))));
            })),
            available ? (React.createElement("button", { onClick: addBundleToCart, className: `btn btn--medium btn--full btn--secondary add-to-cart ${addingToCart ? 'loading' : ''}`, disabled: addingToCart, "data-cg-add-to-cart": "" },
                "Add to cart | ",
                React.createElement("span", null, formattedMoney(bundlePrice.totalBase * quantity)))) : (React.createElement("button", { disabled: true, className: "btn btn--medium btn--full btn--secondary add-to-cart" }, "Sold out"))),
        activeAddOn && (React.createElement("div", { className: `bundle-details__modal ${addOnModalOpen ? 'open' : ''}` },
            React.createElement("div", { className: "bundle-details__modal--inner" },
                React.createElement("button", { className: "bundle-details__modal--close", onClick: () => handleCloseModal('add-on') },
                    React.createElement(IconCross, null)),
                React.createElement("h3", { className: "bundle-details__modal--header-title" }, translations.add_on_modal_title),
                React.createElement("p", { className: "bundle-details__modal--header-message" }, translations.add_on_modal_message),
                React.createElement("div", { className: "bundle-details__modal--product" },
                    React.createElement("img", { className: "bundle-details__modal--product-image", src: activeAddOn.image, height: "210", width: "210" }),
                    React.createElement("h4", { className: "bundle-details__modal--product-title" }, activeAddOn.title)),
                React.createElement("div", { className: "bundle-details__modal--buttons" },
                    React.createElement("button", { onClick: removeAddOn, className: "btn btn--tertiary btn--full" }, translations.add_on_modal_delete_btn),
                    React.createElement("button", { onClick: () => handleCloseModal('add-on'), className: "btn btn--tertiary btn--full" }, translations.add_on_modal_keep_btn)))))));
};
export default VariantsContainer;
